export default [
  {
    title: 'Purchases',
    icon: 'shopping-cart',
    resource: 'Purchases',
    children: [
      {
        title: 'Dashboard',
        route: 'Purchases dashboard',
        resource: 'PurchasesDashboard',
        action: 'manage',
      },
      {
        title: 'Orders',
        route: 'Orders',
        resource: 'Orders'
      },
      // {
      //   title: 'Expenses',
      //   route: 'Incoming invoices'
      // },
      {
        title: 'Expenses',
        route: 'Supplier invoices',
        resource: 'IncomingInvoices'
      },
    ]
  },
]
